import { create } from "zustand";

const useInsightsModal = create(set => ({
  id: null,
  isOpen: false,
  onOpen: (id) => set({isOpen:true, id:id}),
  onClose: () => set({isOpen:false, id:null})
}))

export default useInsightsModal;